import { render, staticRenderFns } from "./PnetMessageNewSideMenu.vue?vue&type=template&id=90720960"
import script from "./PnetMessageNewSideMenu.vue?vue&type=script&lang=js"
export * from "./PnetMessageNewSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports